export default "__VITE_ASSET__Dvr25ZaL__"